module.exports = __webpack_public_path__ + "static/img/31_phase_function_Paper_PointsHejduk_Prediction.b919982.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/raw_data/images/31_phase_function_Paper_PointsHejduk_Prediction.png
// module id = 7ltn
// module chunks = 0